import { render, staticRenderFns } from "./AffixOptions.vue?vue&type=template&id=99bc7ccc"
import script from "./AffixOptions.vue?vue&type=script&lang=js"
export * from "./AffixOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports